<div class="container-fluid complyon-page px-3 px-md-4 px-xl-4 py-3">
  <div class="complyon-shell mx-auto">
    <div class="mb-3">
      <h1 class="complyon-title mb-2 text-l">System settings</h1>
      <p class="complyon-subtitle mb-0 text-s">Tenant configuration, compliance-engine rules, notifications, escalation and security & data policies.</p>
    </div>

    <div class="row g-3">
      <div class="col-12 col-xl-6">
        <div class="complyon-panel rounded-4 overflow-hidden h-100">
          <div class="px-3 px-md-4 pt-3 pt-md-4 pb-3 border-bottom">
            <div class="d-flex align-items-center gap-2">
              <div class="d-inline-flex align-items-center justify-content-center rounded-3 bg-info-subtle text-info-emphasis" style="width: 2rem; height: 2rem;">
                <i class="bi bi-building"></i>
              </div>
              <div class="complyon-section-title text-s">Organisation</div>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table complyon-table align-middle mb-0">
              <tbody>
                <tr v-for="row in organization_rows" :key="row.label">
                  <td class="ps-3 fw-semibold">{{ row.label }}</td>
                  <td class="pe-3 text-end">{{ row.value }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="px-3 px-md-4 pb-3 pb-md-4 pt-3">
            <div class="d-flex flex-wrap gap-2">
              <span class="badge rounded-pill bg-light text-secondary border border-light">Org structure</span>
              <span class="badge rounded-pill bg-light text-secondary border border-light">Reports</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-6">
        <div class="complyon-panel rounded-4 overflow-hidden h-100">
          <div class="px-3 px-md-4 pt-3 pt-md-4 pb-3 border-bottom">
            <div class="d-flex align-items-center gap-2">
              <div class="d-inline-flex align-items-center justify-content-center rounded-3 bg-info-subtle text-info-emphasis" style="width: 2rem; height: 2rem;">
                <i class="bi bi-shield-check"></i>
              </div>
              <div class="complyon-section-title text-s">Compliance engine</div>
            </div>
          </div>

          <div class="px-3 px-md-4 py-3 py-md-4">
            <div v-for="row in compliance_engine_rows" :key="row.label" class="d-flex align-items-center justify-content-between gap-3 py-3 border-bottom">
              <div class="min-w-0">
                <div class="fw-semibold">{{ row.label }}</div>
                <div class="d-flex flex-wrap gap-2 mt-2">
                  <span v-for="tag in row.tags" :key="`${row.label}-${tag}`" class="badge rounded-pill bg-light text-secondary border border-light">{{ tag }}</span>
                </div>
              </div>
              <div class="form-check form-switch m-0">
                <input class="form-check-input" type="checkbox" :checked="row.on" disabled>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-6">
        <div class="complyon-panel rounded-4 overflow-hidden h-100">
          <div class="px-3 px-md-4 pt-3 pt-md-4 pb-3 border-bottom">
            <div class="d-flex align-items-center gap-2">
              <div class="d-inline-flex align-items-center justify-content-center rounded-3 bg-info-subtle text-info-emphasis" style="width: 2rem; height: 2rem;">
                <i class="bi bi-bell"></i>
              </div>
              <div class="complyon-section-title text-s">Notifications & escalation</div>
            </div>
          </div>
          <div class="px-3 px-md-4 py-3 py-md-4">
            <div v-for="row in notification_rows" :key="row.label" class="d-flex align-items-center justify-content-between gap-3 py-3 border-bottom">
              <div class="min-w-0">
                <div class="fw-semibold">{{ row.label }}</div>
                <div class="d-flex flex-wrap gap-2 mt-2">
                  <span v-for="tag in row.tags" :key="`${row.label}-${tag}`" class="badge rounded-pill bg-light text-secondary border border-light">{{ tag }}</span>
                </div>
              </div>
              <div class="text-end text-xs text-secondary">{{ row.value }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-6">
        <div class="complyon-panel rounded-4 overflow-hidden h-100">
          <div class="px-3 px-md-4 pt-3 pt-md-4 pb-3 border-bottom">
            <div class="d-flex align-items-center gap-2">
              <div class="d-inline-flex align-items-center justify-content-center rounded-3 bg-info-subtle text-info-emphasis" style="width: 2rem; height: 2rem;">
                <i class="bi bi-lock"></i>
              </div>
              <div class="complyon-section-title text-s">Security & data</div>
            </div>
          </div>
          <div class="px-3 px-md-4 py-3 py-md-4">
            <div v-for="row in security_rows" :key="row.label" class="d-flex align-items-center justify-content-between gap-3 py-3 border-bottom">
              <div class="min-w-0">
                <div class="fw-semibold">{{ row.label }}</div>
                <div class="d-flex flex-wrap gap-2 mt-2">
                  <span v-for="tag in row.tags" :key="`${row.label}-${tag}`" class="badge rounded-pill bg-light text-secondary border border-light">{{ tag }}</span>
                </div>
              </div>
              <div class="text-end text-xs text-secondary">{{ row.value }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="complyon-panel rounded-4 overflow-hidden">
          <div class="d-flex align-items-start justify-content-between gap-3 px-3 px-md-4 pt-3 pt-md-4 pb-3">
            <div>
              <div class="complyon-section-title text-s">Reset demo data</div>
              <div class="complyon-section-subtitle text-xs">Restore every module's sample records to their original state.</div>
            </div>
            <button type="button" class="btn btn-outline-secondary d-inline-flex align-items-center gap-2">
              <i class="bi bi-arrow-clockwise"></i>
              <span>Reset demo data</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
